import ApiService from "../services/api";

export interface IVehicleFromOccurrence {
  chassis: string;
  licensePlate: string;
  model: string;
  name: string;
}

/**
 * Busca dados de veículos a partir da API de ocorrências
 * Esta API pode ter dados de licensePlate que não estão no endpoint summary
 */
export const fetchVehiclesFromOccurrences = async (
  chassisList: string[], 
  userRole: 'TOWER' | 'CONSULTANT' | 'MANAGER' | 'PARTNERSHIP' = 'MANAGER'
): Promise<IVehicleFromOccurrence[]> => {
  if (!chassisList.length) return [];

  const apiService = new ApiService();

  // Se a primeira role não retornar ocorrências, tentamos outras roles para garantir compatibilidade entre perfis
  const rolesToTry = Array.from(new Set([userRole, 'MANAGER', 'TOWER', 'CONSULTANT', 'PARTNERSHIP']));

  for (const role of rolesToTry) {
    try {
      const response = await apiService.post<any>(
        `/occurrence/list/${role}?page=0&size=50`,
        { chassisList }
      );

      if (response.status === 200) {
        const occurrences = response.data.occurrences || [];
        
        if (!occurrences.length) {
          // sem ocorrências para essa role, tentar próxima
          continue;
        }

        // Extrai dados únicos dos veículos das ocorrências
        const vehiclesMap = new Map<string, IVehicleFromOccurrence>();

        occurrences.forEach((occurrence: any) => {
          const vehicle = occurrence.vehicle;
          if (vehicle?.chassis && !vehiclesMap.has(vehicle.chassis)) {
            // Algumas respostas usam `licensePlate`, outras `plate` — normalize aqui
            const plate = vehicle.licensePlate ?? vehicle.plate ?? '';
            vehiclesMap.set(vehicle.chassis, {
              chassis: vehicle.chassis,
              licensePlate: plate,
              model: vehicle.model || '',
              name: vehicle.name || '',
            });
          }
        });

        const result = Array.from(vehiclesMap.values());
        return result;
      }
    } catch (error) {
      console.error(`Erro ao buscar dados de veículos das ocorrências com role=${role}:`, error);
      // tenta próxima role
      continue;
    }
  }

  return [];
};